<template>
  <div class="about-wrapper">
    <container>
      <div class="about-header">
        <h2 class="about-header__title">Hakkımızda</h2>
        <p class="about-header__text"><span>Türkiye’nin ilk yurt tanıtım rehberi yurtlarburada.com</span> 2006 yılından bu yana yurt arayan üniversite öğrencileriyle yurt sahiplerini bir araya getiriyor. 10 yılı aşkın süredir yurt sektöründe olmanın sağladığı deneyim ile aradığınız yurdu en hızlı ve kolay şekilde bulabilmeniz için çalışıyoruz.
</p>
        <div class="about-header__img">
          <img src="@/assets/img/hakkimizda/about-smile.svg" alt="">
        </div>

      </div>
    </container>

    <div class="about-info">
      <container>
        <div class="about-info__item">
          <div class="about-info__item_img">
            <img src="@/assets/img/hakkimizda/dom.svg" alt="">
          </div>
          <div class="about-info__number">
            <strong>3.700+</strong>
            <p>Kayıtlı Yurt</p>
          </div>
          <div class="about-info__item_text">
          </div>
        </div>

        <div class="about-info__item">
          <div class="about-info__item_img">
            <img src="@/assets/img/hakkimizda/student.svg" alt="">
          </div>
          <div class="about-info__number">
            <strong>5.400+</strong>
            <p>Öğrenci</p>
          </div>
          <div class="about-info__item_text">
          </div>
        </div>

        <div class="about-info__item">
          <div class="about-info__item_img">
            <img src="@/assets/img/hakkimizda/visitor.svg" alt="">
          </div>
          <div class="about-info__number">
            <strong>2 Milyon+</strong>
            <p>Yıllık Ziyaretçi</p>
          </div>
          <div class="about-info__item_text">
          </div>
        </div>

        <div class="about-info__item">
          <div class="about-info__item_img">
            <img src="@/assets/img/hakkimizda/view.svg" alt="">
          </div>
          <div class="about-info__number">
            <strong>4 Milyon+</strong>
            <p>Yıllık Görüntülenme</p>
          </div>
          <div class="about-info__item_text">
          </div>
        </div>
      </container>
    </div>

    <div class="about-why">
      <container>
        <div class="section__header">
          <div class="section__title">
            <span class="color-light-green">Neden</span> Yurtlar Burada<span
            class="color-light-green">.com</span>
          </div>
        </div>

        <h1 class="about-why__title">Yurtlarburada.com, çalışan profili itibariyle sizi çok iyi tanıyor!</h1>
        <div class="about-why__list">
          <ul>
            <li>Şehirlerdeki en popüler yurtları sizin için araştırır ziyaret eder ve yayınlarız.
            </li>
            <li>Yurt bilgileri objektif şekilde oluşturulur ve size sunulur.
            </li>
            <li>Yurt sıralamalarında ağırlıklı olarak kullanıcı görüşleri göz önüne alınır.
            </li>
            <li>Oldukça basit ve kolay şekilde yurt yetkilileri ile iletişim kurabilirsiniz.
            </li>
            <li>Kafanızda oluşan sorular ve sorunlar için telefon ile müşteri hizmetlerimize ulaşarak dilediğiniz zaman bilgi ve destek alabilirsiniz.
            </li>
            <li>Kriterlerinize uygun yurdu bulamazsanız, ücretsiz olarak bize ulaşın! Sizin için en uygun yurdu bulmanıza yardımcı olalım.
            </li>
            <li>Türkiye'nin saygın kuruluşlarından çeşitli alanlarda ödül alan ve başarı elde eden tek yurt tanıtım rehberiyiz. (Türkiye Bilişim Derneği Bilişim Yıldızları Ödülü, Bilgi Üniversitesi Genç Sosyal Girişimciler Yarışması)
 
            </li>
            <li>Ülkemizin saygın yayın organı TRT'nin öğrencilere yurt bulma konusunda referans gösterdiği tek yurt tanıtım rehberiyiz.
            </li>
            <li>Arama motorlarında bulamayacağınız, saatlerce vaktinizi harcamanızın önüne geçerek size uygun olan yurtları basit bir şekilde listeleyen, öğrenci dostu bir yurt tanıtım rehberiyiz.
            </li>
            <li> Yurt fiyatlarını öğrenmek için saatlerce araştırma yapmanıza, onlarca numara tuşlamanıza gerek yok! Şehir ve üniversite listeleme sayfalarımızdan ya da yurt tanıtım sayfalarımızdan 'Yurtlar Beni Arasın' formunu doldurun, yurtlar size ulaşsın!
            </li>

          </ul>
        </div>
      </container>
    </div>

  </div>
</template>

<script>
import MediaCard from '@/components/MediaCard'
import ImageLightBox from '@/components/ImageLightBox'

export default {
  name: 'About',
  components: {
    MediaCard, ImageLightBox
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Hakkımızda',
      link: [
        { rel: 'canonical', href: window.location.origin + '/hakkimizda/' }
      ]
    }
  },
  data () {
    return {
      display: false,
      IndexNo: null,
      MediaArray: {},
      mediaList: [
        {
          id: 0,
          cover: require('@/assets/img/basin/basin-1.png'),
          image: 'http://i.hurimg.com/i/hurriyet/75/0x0/5b4a9cc0eb10bb2434e7fb69.jpg',
          date: '18 Mart 2018',
          title: 'TRT 1',
          author: 'Muhammed Erdem'
        },
        {
          id: 1,
          cover: require('@/assets/img/basin/basin-2.png'),
          image: 'https://im.haberturk.com/2018/10/19/2183896_05967b8ab6f7a0a0e836443fcca7012b_640x640.jpg',
          date: '18 Mart 2018',
          title: 'Milliyet',
          author: 'Muhammed Erdem'
        },
        {
          id: 2,
          cover: require('@/assets/img/basin/basin-3.png'),
          image: 'http://i.hurimg.com/i/hurriyet/75/0x0/5add304ceb10bb358050dfe0.jpg',
          date: '18 Mart 2018',
          title: 'Posta',
          author: 'Muhammed Erdem'
        },
        {
          id: 3,
          cover: require('@/assets/img/basin/basin-1.png'),
          image: 'http://i.hurimg.com/i/hurriyet/75/0x0/5add304ceb10bb358050dfe0.jpg',
          date: '18 Mart 2018',
          title: 'TRT 1',
          author: 'Muhammed Erdem'
        },
        {
          id: 4,
          cover: require('@/assets/img/basin/basin-2.png'),
          image: 'http://i.hurimg.com/i/hurriyet/75/0x0/5add304ceb10bb358050dfe0.jpg',
          date: '18 Mart 2018',
          title: 'Milliyet',
          author: 'Muhammed Erdem'
        },
        {
          id: 5,
          cover: require('@/assets/img/basin/basin-1.png'),
          image: 'http://i.hurimg.com/i/hurriyet/75/0x0/5add304ceb10bb358050dfe0.jpg',
          date: '18 Mart 2018',
          title: 'TRT 1',
          author: 'Muhammed Erdem'
        },
        {
          id: 6,
          cover: require('@/assets/img/basin/basin-2.png'),
          image: 'http://i.hurimg.com/i/hurriyet/75/0x0/5add304ceb10bb358050dfe0.jpg',
          date: '18 Mart 2018',
          title: 'Milliyet',
          author: 'Muhammed Erdem'
        },
        {
          id: 7,
          cover: require('@/assets/img/basin/basin-2.png'),
          image: 'http://i.hurimg.com/i/hurriyet/75/0x0/5add304ceb10bb358050dfe0.jpg',
          date: '18 Mart 2018',
          title: 'Milliyet',
          author: 'Muhammed Erdem'
        },
        {
          id: 8,
          cover: require('@/assets/img/basin/basin-3.png'),
          image: 'http://i.hurimg.com/i/hurriyet/75/0x0/5add304ceb10bb358050dfe0.jpg',
          date: '18 Mart 2018',
          title: 'Posta',
          author: 'Muhammed Erdem'
        }
      ]
    }
  },

  methods: {
    dataGo (data, index) {
      this.display = true
      this.MediaArray = data
      this.IndexNo = index
    },
    closeBox () {
      this.display = false
    },
    nextNotice () {
      this.MediaArray = []
      this.IndexNo++
      this.MediaArray = this.mediaList[this.IndexNo]
    },

    prevNotice () {
      this.MediaArray = []
      this.IndexNo--
      this.MediaArray = this.mediaList[ this.IndexNo ]
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/scss/components/about";
</style>
